/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// This is the ugliest code I have ever written.


App.message_support = class message_support {

  constructor(chartId = "message-modal-credits-pie-chart", selectize_prefix = "") {
    this.form_id = this.form_id.bind(this);
    this.init_linkify = this.init_linkify.bind(this);
    this.init_datepicking = this.init_datepicking.bind(this);
    this.default_time = this.default_time.bind(this);
    this.show_schedule_later = this.show_schedule_later.bind(this);
    this.clear_schedule_later = this.clear_schedule_later.bind(this);
    this.update_send_language = this.update_send_language.bind(this);
    this.init_chart = this.init_chart.bind(this);
    this.modal_closed = this.modal_closed.bind(this);
    this.reset_modal = this.reset_modal.bind(this);
    this.reset_char_counter = this.reset_char_counter.bind(this);
    this.handle_modal_triggers = this.handle_modal_triggers.bind(this);
    this.fetch_new_vars = this.fetch_new_vars.bind(this);
    this.selectize = this.selectize.bind(this);
    this.set_initial_from_name = this.set_initial_from_name.bind(this);
    this.set_initial_from_name_in_select_only = this.set_initial_from_name_in_select_only.bind(this);
    this.from_name_changed = this.from_name_changed.bind(this);
    this.parse_new_vars = this.parse_new_vars.bind(this);
    this.clear_contacts = this.clear_contacts.bind(this);
    this.add_contact = this.add_contact.bind(this);
    this.remove_contact = this.remove_contact.bind(this);
    this.add_chosen_contacts = this.add_chosen_contacts.bind(this);
    this.remove_all_contacts = this.remove_all_contacts.bind(this);
    this.remove_chosen_contacts = this.remove_chosen_contacts.bind(this);
    this.update_message_totals = this.update_message_totals.bind(this);
    this.render_option = this.render_option.bind(this);
    this.render_item = this.render_item.bind(this);
    this.toggle_highlighted_details = this.toggle_highlighted_details.bind(this);
    this.toggle_summary = this.toggle_summary.bind(this);
    this.validate = this.validate.bind(this);
    if (!App.logged_in()) { return false; }

    // Search for values off this node
    this.root_node = $(`#${chartId}`).closest('.message-modal');

    this.chartId             = chartId;
    this.groups              = {}; // groups and their contact memberships
    this.contact_memberships = {}; // contact memberships from JSON request
    this.chosen_contacts     = {}; // Selected contacts and dup counts
    this.credits             = 0;  // SMS count for this message
    this.emails              = 0;  // Email count for this message

    this.selectize(selectize_prefix);
    this.init_datepicking();
    this.init_chart();
    this.fetch_new_vars();
    this.init_linkify();

    this.root_node
      .off("click", ".modal-state", this.handle_modal_triggers)
      .on("click", ".modal-state", this.handle_modal_triggers);
    this.root_node
      .off("click", ".js-show-schedule-later", this.show_schedule_later)
      .on("click", ".js-show-schedule-later", this.show_schedule_later);
    this.root_node
      .off("click", ".js-clear-schedule-later", this.clear_schedule_later)
      .on("click", ".js-clear-schedule-later", this.clear_schedule_later);
    this.root_node
      .off("submit", ".js-message-form", this.validate)
      .on("submit", ".js-message-form", this.validate);
    this.root_node
      .off("click", ".modal-close", this.modal_closed)
      .on("click", ".modal-close", this.modal_closed);
    this.root_node
      .off("click", ".js-new-msg-summary", this.toggle_summary)
      .on("click", ".js-new-msg-summary", this.toggle_summary);
  }


  static open_new_modal() {
    return $(".js-message-modal-trigger-top-nav").click();
  }


  // NOTE this may not be necessary anymore now that all message modals are opened remotely
  static reset_new_modal() {
    console.log("[DEPRECATED?] Reset new modal");
    return window.new_message_support.reset_modal();
  }


  // NOTE this may not be necessary anymore now that all message modals are opened remotely
  static reset_edit_modal() {
    console.log("[DEPRECATED?] Reset edit modal");
    return window.edit_message_support.reset_modal();
  }


  static submit_disable() {
    return $('.js-message-modal-submit').prop('disabled', true);
  }

  static submit_enable() {
    return $('.js-message-modal-submit').prop('disabled', false);
  }

  static submit_busy(evt) {
    const busy = evt.detail
    console.log("submit_busy: ", busy);
    if (busy) {
      App.message_support.submit_disable();
    } else {
      App.message_support.submit_enable();
    }
  }


  form_id() {
    return this.root_node.find(".js-message-form").attr("id");
  }


  init_linkify() {
    return new App.LinkifyingEditor(`#${this.form_id()} .js-form-message-body`, `#${this.form_id()} .js-linkifying-message-body`);
  }


  init_datepicking() {
    this.date_field = this.root_node.find(".js-msg-datepicker");
    this.time_field = this.root_node.find(".js-msg-timepicker");

    this.date_field.pickadate({
                        format: "mm/dd/yyyy",
                        weekdaysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                        showMonthsShort: true,
                        editable: true, // necessary to trigger html5 validation
                        min: new Date()
    });

    this.time_field.pickatime({
                        interval: 15,
                        editable: true,
                        onOpen: this.default_time
    });

    // Manual event handling necessary since v3.5.4 when "editable: true"
    this.date_field
      .off("click focus")
      .on("click focus", () => {
        // App.log("should be opening datepicker");
        return this.date_field.pickadate("open");
    });

    this.time_field
      .off("click focus")
      .on("click focus", () => {
        // App.log("should be opening timepicker");
        return this.time_field.pickatime("open");
    });

    return this.date_field
      .off("change", this.update_send_language)
      .on("change", this.update_send_language);
  }


  // Seems the nearest time is highlighted for us, but it isn't
  // scrolled into view. v3.5.6 scrolls it into view, but v3.5.6
  // is broken in my testing (won't even show the time picker?)
  // So we'll scroll it manually
  default_time() {
    const holder = this.root_node.find(".picker__holder");
    const item   = this.root_node.find(".picker__list-item--highlighted");
    return holder.scrollTop(item.position().top);
  }


  show_schedule_later(evt) {
    this.root_node.find(".js-show-schedule-later").hide();
    this.root_node.find(".js-msg-schedule-container").show();
    return this.update_send_language(evt);
  }


  clear_schedule_later(evt) {
    this.date_field.val("");
    this.time_field.val("");
    this.root_node.find(".js-show-schedule-later").show();
    this.root_node.find(".js-msg-schedule-container").hide();
    return this.update_send_language(evt);
  }


  update_send_language(evt) {
    const submit_btn = this.root_node.find('.js-message-modal-submit');

    if ($(".js-msg-schedule-container").is(":visible")) {
      return submit_btn.val("Save");
    } else {
      return submit_btn.val("Send");
    }
  }


  init_chart() {
    const chart = Chartkick.charts[this.chartId];

    if (chart) {
      const total = parseInt(this.root_node.find('.js-msg-credits-total').text(), 10);
      const used  = parseInt(this.root_node.find('.js-msg-credits-used').text(), 10);

      this.plan_credits      = total;            // Credits in the current plan
      this.credits_available = total-used;       // Available credits
      return this.credits_used      = chart.data[0][1]; // Credits used
    }
  }


  modal_closed(evt) {
    // App.log("in modal_closed, evt: ", evt);
    if ($(evt.target).attr('for') === 'modal-new-message') {
      return this.reset_modal();
    }
    App.unsubscribe('messages-modal.busy', App.message_support.submit_busy)
  }


  // FIXME obsolete since the modal is now fetched via ajax each time?
  reset_modal() {
    return App.log("in reset_modal");
  }

  clear_form() {
    // App.log("in clear_form");
    this.root_node.find(".js-form-message-body").val("");
    this.root_node.find(".js-msg-datepicker").val("");
    this.root_node.find(".js-msg-timepicker").val("");
    return this.root_node.find(".js-send-social-cb").prop("checked", false);
  }


  reset_char_counter() {
    return this.root_node.find(".js-form-message-body").change();
  }


  handle_modal_triggers(evt) {
    // App.log("in handle_modal_triggers: ", evt);
    this.reset_char_counter();

    const state_node = this.root_node.find(".modal-state");
    const mode = state_node.attr("data-mode");
    const in_reply_to = state_node.attr("data-in-reply-to");

    if (state_node.is(":checked")) {
      if (mode === "edit") {
        return this.set_initial_from_name_in_select_only();

      } else {
        if (in_reply_to.length > 0) {
          const new_msg_node = App.message_modal_replies.build_reply_node(in_reply_to);
          const sender_id = $(new_msg_node).closest('.js-msg').attr('data-sender-id');
          return App.message_modal_replies.populate_reply(new_msg_node, sender_id);
        } else {
          return this.set_initial_from_name();
        }
      }
    }
  }


  fetch_new_vars() {
    // App.log("in fetch_new_vars");
    return $.getJSON('/messages/new.json', this.parse_new_vars);
  }


  selectize(prefix = "") {
    console.log('in message_support.selectize');
    $(`#${prefix}message-from`).selectize({
      plugins: ["remove_button"],
      onChange: this.from_name_changed
    });

    return $(`#${prefix}message-to`).selectize({
      onItemAdd: this.add_chosen_contacts,
      onItemRemove: this.remove_chosen_contacts,
      onClear: this.remove_all_contacts,
      labelField: 'text',
      valueField: 'value',
      searchField: ['text', 'email', 'number'],
      render: { option: this.render_option, item: this.render_item },
      onType: this.toggle_highlighted_details,
      plugins: ["remove_button"]});
  }


  // When the msg modal loads, prepend the last selected From name to the body
  set_initial_from_name() {
    const default_value = this.root_node.find(".js-msg-from-options")[0].options[0].value;
    const last_selected = Cookies.get("lsfn") || default_value;
    return this.root_node.find(".js-msg-from-options")[0].selectize.setValue(last_selected);
  }


  set_initial_from_name_in_select_only() {
    // App.log("in set_initial_from_name_in_select_only, @: ", this);
    this.do_not_change_body = true;
    return this.set_initial_from_name();
  }


  // 1. Clear the old prepended value from body field if present
  // 2. Prepend the new value unless "[none]"
  // 3. Remember the new value
  from_name_changed(new_value) {
    // App.log(`in from_name_changed(${new_value}), @: `, this);
    const {
      selectize
    } = this.root_node.find(".js-msg-from-options")[0];
    const msg_body = this.root_node.find(".js-form-message-body");

    $.each(selectize.options, function() {
      const val = this.value;
      if (val !== "[none]") {
        const re = new RegExp(`^${val}`, "i");
        return msg_body.val(msg_body.val().replace(re, ""));
      }
    });

    if ((new_value !== "[none]") && !this.do_not_change_body) {
      const orig_body = msg_body.val();
      msg_body.val(`${new_value}${orig_body}`);
    }

    msg_body.change().focus();
    Cookies.set("lsfn", new_value);
    return this.do_not_change_body = null;
  }


  parse_new_vars(data) {
    // App.log("in parse_new_vars: ", data);

    const selectize_to = this.root_node.find(".js-message-to-select")[0].selectize;


    // "groups": [
    //   {
    //     "id": 13612,
    //     "name": "JJ Employees",
    //     "contact_memberships": []
    //   },
    //   {
    //     "id": 13609,
    //     "name": "BroBros8 big name blah",
    //     "contact_memberships": [
    //       {
    //         "id": 2191
    //       },
    //       {
    //         "id": 17
    //       }
    //     ]
    //   }
    // ]
    for (var g of data.groups) {
      this.groups[g.id.toString()] = g;
    }
    // App.log("  @groups: ", this.groups);
    window.groups = this.groups;

    // "contact_memberships": [
    //   {
    //     "id": 2191,
    //     "first_name": "",
    //     "last_name": "",
    //     "email": "herp@derp.perp",
    //     "mobile_number": null
    //   },
    //   {
    //     "id": 276,
    //     "first_name": "Barry",
    //     "last_name": "Angradi",
    //     "email": "BAngradi@jjmcdonnell.com",
    //     "mobile_number": "4103759410"
    //   }
    // ]
    for (var cm of data.contact_memberships) {
      var name;
      this.contact_memberships[cm.id.toString()] = cm;

      if (!cm.first_name && !cm.last_name) {
        name = cm.mobile_number ? cm.mobile_number : cm.email;
      } else {
        name = `${cm.first_name} ${cm.last_name}`;
      }

      // Fill out options
      var opts = {value: 'c'+cm.id, text: name};
      if ((cm.email != null) && (cm.email !== name)) { opts.email = cm.email; }
      if ((cm.mobile_number != null) && (cm.mobile_number !== name)) { opts.number = cm.mobile_number; }
      selectize_to.addOption(opts);
    }

    window.contact_memberships = this.contact_memberships;
    this.remove_all_contacts();

    // preselect contact
    if ($('.msg-single').length > 0) {
      const cid = 'c' + $('.msg-single .msg').attr('data-sender-id');
      selectize_to.clear();
      selectize_to.setValue(cid);
    }

    return selectize_to.items.map((item) =>
      this.add_chosen_contacts(item, null));
  }


  clear_contacts() {
    // App.log("in clear_contacts");

    const selectize_to = this.root_node.find(".js-message-to-select")[0].selectize;
    if ($('.msg-single').length > 0) {
      selectize_to.clear();
    }

    return this.contact_memberships.map((cm) =>
      selectize_to.removeOption('c'+cm.id));
  }


  add_contact(contact_id) {
    // App.log("in add_contact: ", contact_id);
    const cid = contact_id.toString();

    if (this.chosen_contacts[cid] != null) {
      return this.chosen_contacts[cid]['copies'] += 1;
    } else {
      const cm = this.contact_memberships[cid];
      // App.log(`  adding cm[${cid}]: `, cm);
      if (!cm) { return; }
      this.chosen_contacts[cid] = cm;
      this.chosen_contacts[cid].copies = 1;

      if (cm.email) { this.emails++; }
      if (cm.mobile_number) { return this.credits++; }
    }
  }


  remove_contact(contact_id) {
    // App.log("in remove_contact: ", contact_id);
    const cid = contact_id.toString();

    if (this.chosen_contacts[cid] != null) {
      if (this.chosen_contacts[cid].copies > 1) {
        return this.chosen_contacts[cid].copies -= 1;
      } else {
        const cm = this.contact_memberships[cid];
        if (cm.email) { this.emails--; }
        if (cm.mobile_number) { this.credits--; }
        return delete this.chosen_contacts[cid];
      }
    }
  }


  add_chosen_contacts(value, item) {
    // App.log("in add_chosen_contacts: ", value, item);
    if (value != null) {
      const val_id = value.substring(1);
      // App.log("  val_id: ", val_id);
      if (value.charAt(0) === 'g') {
        if (this.groups[val_id] != null) {
          for (var m of this.groups[val_id].contact_memberships) {
            this.add_contact(m.id);
          }
        }
      } else {
        this.add_contact(val_id);
      }
    }

    return this.update_message_totals();
  }


  remove_all_contacts() {
    // App.log("in remove_all_contacts");
    this.chosen_contacts = {};
    this.credits = 0;
    this.emails = 0;
    return this.update_message_totals();
  }


  remove_chosen_contacts(value) {
    // App.log("in remove_chosen_contacts: ", value);
    if (value != null) {
      const val_id = value.substring(1);
      if (value.charAt(0) === 'g') {
        if (this.groups[val_id] != null) {
          for (var m of this.groups[val_id].contact_memberships) {
            this.remove_contact(m.id);
          }
        }
      } else {
        this.remove_contact(val_id);
      }
    }

    return this.update_message_totals();
  }


  update_message_totals() {
    const recipient_count = Object.keys(this.chosen_contacts).length;
    // App.log("in update_message_totals, recipient_count: ", recipient_count);

    this.root_node.find('.js-new-msg-recipient-count').text(recipient_count);
    this.root_node.find('.js-msg-count-total').text(recipient_count);
    this.root_node.find('.js-msg-count-email').text(this.emails);
    this.root_node.find('.js-msg-count-text').text(this.credits);
    this.root_node.find('.js-msg-credits-cost').text(this.credits);

    App.message_modal_charts.update_charts(
      this.chartId,
      this.credits_available,
      this.credits,
      this.plan_credits,
      this.credits_used);

    return App.message_modal_charts.adjust_gradient(this.plan_credits, this.credits_available);
  }


  render_option(data, escape) {
    // App.log("in render_option: data: ", data);
    const type = data.value[0] === "g" ? "group" : "contact";

    let html = `\
<div class='message-modal__option'> \
<span class='icon icon-msg-recipient-${type}'></span> \
${escape(data.text)}\
`;

    if (data.number) {
      html += "<span class='message-modal__option-number'> - "+escape(data.number)+"</span>";
    }
    if (data.email) {
      html += "<span class='message-modal__option-email'> - "+escape(data.email)+"</span>";
    }

    return html+"</div>";
  }


  render_item(data, escape) {
    const type = data.value[0] === "g" ? "group" : "contact";

    return `\
<div class='item' data-value='${escape(data.value)}'> \
<span class='icon icon-msg-${type}'></span> \
${escape(data.text)} \
<a href='javascript:void(0)' class='remove' tabindex='-1' title='Remove'>×</a> \
</div>\
`;
  }


  toggle_highlighted_details(str) {
    $(".highlight").parent(".message-modal__option-number").show();
    $(".highlight").parent(".message-modal__option-email").show();

    $(".message-modal__option-number:not(:has(.highlight))").hide();
    return $(".message-modal__option-email:not(:has(.highlight))").hide();
  }


  toggle_summary(evt) {
    evt.preventDefault();
    this.root_node.find(".js-message-modal-footer-container").toggleClass("open");
    return this.root_node.find(".js-message-modal-content").animate({ scrollTop: "200px" });
  }


  // What a mess
  validate(evt) {
    evt.preventDefault();

    // Double-submit prevention
    if (this.submitting) { return false; }
    this.submitting = true;

    const errors = {};
    const $form = $(evt.currentTarget);

    const $submit = $form.find(".js-message-modal-submit");
    $submit.prop('disabled', true);

    $form.find(".invalid").removeClass("invalid");
    const $recipients = $form.find(".js-message-to-select");
    const $body = $form.find(".js-form-message-body");

    const has_recipients = !!$recipients.val();
    const has_message = !!$body.val();
    const is_scheduled = $form.find(".js-msg-schedule-container").is(":visible");
    const message_id = $form.attr("id").replace(/\D/g, "") || "null";

    if (!has_recipients) {
      errors["At least one recipient"] = ["is required"];
      $recipients.addClass("invalid");
    }

    if (!has_message) {
      errors["Message body"] = ["is required"];
      $body.addClass("invalid");
    }

    if (is_scheduled) {
      const $date = $form.find(".js-msg-datepicker");
      const $time = $form.find(".js-msg-timepicker");
      const has_date = !!$date.val();
      const has_time = !!$time.val();
      if (!has_date) {
        errors["Send-at date"] = ["is required"];
        $date.addClass("invalid");
      }
      if (!has_time) {
        errors["Send-at time"] = ["is required"];
        $time.addClass("invalid");
      }
    }

    const ok = $.isEmptyObject(errors);
    if (ok) {
      App.FormErrors.clear_all();
    } else {
      new App.FormErrors({
        class_name: "message",
        id: message_id,
        errors
      });
    }

    window.setTimeout((() => $submit.prop('disabled', false)), 2000);
    window.setTimeout((() => { return this.submitting = false; }), 2000);
    return ok;
  }
};

